import React from "react";
import project1 from "../../../src/img/projects/lg.jpg";
import project2 from "../../../src/img/projects/cr.jpg";
import project3 from "../../../src/img/projects/sp.jpg";
import project4 from "../../../src/img/projects/fn.jpg";
import { Box, Chip, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const courses = [
  { course_name: "LG FIRST STANDARD", id: 1,course_status:"Active" },
  { course_name: "LG ECPC", id: 2,course_status:"Inactive" },
  { course_name: "LG LKG 1 YEAR", id: 3,course_status:"Active" },
  { course_name: "LG FOUNDATION HINDI", id: 4,course_status:"Active" },
];

const CourseCard = () => {
  const navigate = useNavigate();

  const handleCourseClick = (id) => {
    navigate(`/my-workspace/course-options`);
  };

  return (
    <Box>
      <Grid container spacing={3}>
        {courses.map((course) => (
          <Grid item xs={12} md={4} sm={6} key={course.id}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: 3,
                borderRadius: 2,
                position:"relative",
                gap:2,
                cursor: "pointer",
                backgroundImage: "linear-gradient(to right, #77567A, #C47AC0)",
              }}
              onClick={() => handleCourseClick(course.id)}
            >
                <Icon width={20} height={20} icon={"fa:book"} color="#fff"/>
              <Typography variant="subtitle1" color={"white"}>
                {course.course_name}
              </Typography>
              <Box sx={{
                position:"absolute",
                px:'6px',
                py:'3px',
                borderRadius:2,
                backgroundColor:"#fff",
                color:"#000",
                right:'10px',
                fontSize:'14px',
                top:'10px',
              }}>
                {course.course_status}
                </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CourseCard;
